import React, { useState } from 'react';
import { Button } from "antd";
// import "./OutlinedButton.css";
const OutlinedButton = (props) => {
  const { text, onClick, selected , style , icon , isDisabled = false, size="default", dataTestId } = props;
  const handleClick = () => {
    onClick();
  };

  return (
    <Button
      data-testid={`${dataTestId}`}
      className={ `outlined-button ${selected ? "filled" : ""}` }
      onClick={ handleClick }
      style={ style || {} }
      icon={ icon }
      disabled={ isDisabled }
      size={size}
    >
      { text }
    </Button>
  );
};

export default OutlinedButton;
